export const EMPTY_DEST = "—";

export const DESTINATIONS = [
  {
    code: "STEEL",
    label: {
      en: "STEEL MILL",
      uk: "МЕТКОМБІНАТ",
      ru: "МЕТКОМБИНАТ",
      bg: "МЕТАЛУРГИЧЕН",
    },
  },
  {
    code: "CHP",
    label: {
      en: "CHP-2",
      uk: "ТЕЦ-2",
      ru: "ТЭЦ-2",
      bg: "ТЕЦ-2",
    },
  },
  {
    code: "PORT",
    label: {
      en: "SEA PORT",
      uk: "МОРСЬКИЙ ПОРТ",
      ru: "МОРСКОЙ ПОРТ",
      bg: "МОРСКО ПРИСТАНИЩЕ",
    },
  },
  {
    code: "EXPORT",
    label: {
      en: "EXPORT",
      uk: "ЕКСПОРТ",
      ru: "ЭКСПОРТ",
      bg: "ЕКСПОРТ",
    },
  },
  {
    code: "POWER",
    label: {
      en: "POWER PLANT-1",
      uk: "ТЕС-1",
      ru: "ТЭС-1",
      bg: "ЕЦ-1",
    },
  },
  {
    code: "COKE",
    label: {
      en: "COKE PLANT",
      uk: "КОКСОХІМ",
      ru: "КОКСОХИМ",
      bg: "КОКСОВ ЗАВОД",
    },
  },
  {
    code: "DEPOT",
    label: {
      en: "MINE DEPOT",
      uk: "ШАХТА-СКЛАД",
      ru: "ШАХТА-СКЛАД",
      bg: "МИНЕН СКЛАД",
    },
  },
];

export const DEST_CODES = DESTINATIONS.map((d) => d.code);

export function destLabel(code, lang) {
  if (code == null || code === "" || code === EMPTY_DEST) return EMPTY_DEST;
  const dest = DESTINATIONS.find((d) => d.code === code);
  if (!dest) return String(code);
  return dest.label[lang] || dest.label.en || String(code);
}
